import { gql } from '@apollo/client'

export const GET_PAYMENT_SESSION_GQL = gql`
query get_payment_session($price_id: ID!) {
	payment_session(price_id:$price_id) {
		id
	}
}`